// Утилиты для формирования URL изображений
export const getImageUrl = (imagePath) => {
  if (!imagePath) return '';
  if (/^https?:\/\//.test(imagePath)) return imagePath;
  const cleanPath = String(imagePath).replace(/^\/+/, '');
  return `/static/${cleanPath}`;
};

export const getStaticPath = (imagePath) => {
  if (!imagePath) return '';
  if (/^https?:\/\//.test(String(imagePath))) return imagePath;
  return `/static/${String(imagePath).replace(/^\/+/, '')}`;
};

// Возвращает URL уменьшенной версии (серверный ресайзер /img)
// width — желаемая ширина в пикселях
export const getThumbUrl = (imagePath, width = 400, fmt = 'auto') => {
  if (!imagePath) return '';
  // Абсолютные ссылки оставляем как есть
  if (/^https?:\/\//i.test(String(imagePath))) {
    return String(imagePath);
  }
  const base = String(imagePath).replace(/^\/static\//, '');
  const dotIdx = base.lastIndexOf('.');
  const name = dotIdx !== -1 ? base.slice(0, dotIdx) : base;

  // Если хотим именно "thumb" — пробуем использовать заранее сгенерированный *_thumb.webp
  if (fmt === 'thumb') {
    return `/static/${name}_thumb.webp`;
  }

  // Во всех остальных случаях просто возвращаем основной файл из /static
  return `/static/${base}`;
};

// Возвращает набор источников для <picture>: avif, webp, fallback
export const buildPictureSources = (imagePath, width = 400) => {
  if (!imagePath) {
    return { avif: undefined, webp: undefined, fallback: '' };
  }
  // В ПРОДЕ главная цель — надёжно показывать фото.
  // Поэтому здесь больше не строим .avif/.webp вообще, чтобы не ловить 404.
  // Отдаём только fallback-URL.
  return {
    avif: undefined,
    webp: undefined,
    fallback: getImageUrl(imagePath)
  };
};
